module.exports = __webpack_public_path__ + "media/images/social/in-11ac89f7367de04df4e009d15f58d925.svg";